/**
 * Created by Administrador on 9/27/2016.
 */
(function(){
   'use strict';

    var tablePrintExport = {
        templateUrl: 'app/components/table/tablePrintExport.html',
        controller: tablePrintExportController,
        controllerAs: 'vm'
    }

    angular
        .module('completeAir')
        .component('tablePrintExport', tablePrintExport);

    function tablePrintExportController(){

    }
})();
